import { render, staticRenderFns } from "./pcAnalyzeDietLog.vue?vue&type=template&id=b0896170&scoped=true&"
import script from "./pcAnalyzeDietLog.vue?vue&type=script&lang=js&"
export * from "./pcAnalyzeDietLog.vue?vue&type=script&lang=js&"
import style0 from "./pcAnalyzeDietLog.vue?vue&type=style&index=0&id=b0896170&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0896170",
  null
  
)

component.options.__file = "pcAnalyzeDietLog.vue"
export default component.exports